import LocationPin from '@client-shared/models/location-pin.model'
import TaskComment from '@client-shared/models/task-comment.model'

export default class Task {
  constructor ({ _id, projectId, title, description, pfFileIds, created, modified, published, lastStateChange, trashed, dueDate, consecutiveNumber, type, tags, creatorUserId, creatorRole, assigneeUserId, location1, location2, location3, location4, locationLayerId, locationLayerVersionId, latestPinNumber, locationPins, locationMapImage, state, comments }) {
    this._id = _id
    this.creatorUserId = creatorUserId
    this.creatorRole = creatorRole
    this.assigneeUserId = assigneeUserId
    this.projectId = projectId
    this.title = title
    this.description = description
    this.pfFileIds = pfFileIds || []
    this.created = created
    this.modified = modified
    this.published = published
    this.lastStateChange = lastStateChange
    this.trashed = trashed
    this.dueDate = dueDate
    this.consecutiveNumber = consecutiveNumber
    this.type = type
    this.tags = tags || []
    this.location1 = location1
    this.location2 = location2
    this.location3 = location3
    this.location4 = location4
    // The API accepts and can store null for a cleared layer; the clients only know undefined
    // (the selectors emit it, the multi-action editors reserve null for "mixed").
    this.locationLayerId = locationLayerId ?? undefined
    this.locationLayerVersionId = locationLayerVersionId ?? undefined
    this.latestPinNumber = latestPinNumber
    this.locationPins = locationPins ? locationPins.map(pin => new LocationPin(pin)) : []
    this.locationMapImage = locationMapImage
    this.state = state
    this.comments = comments ? comments.map(comment => new TaskComment(comment)) : []

    this.computed = {
      isTask: true,
    }
  }
}
